import { MutableRefObject, useCallback, useLayoutEffect, useRef, useState } from 'react'
import useResizeObserver from '@react-hook/resize-observer'

interface Size {
  width: number
  height: number
}

/**
 * Hook to get an Element size and update it using Resize observer (polyfilled)
 */
function useElementSize<T extends HTMLElement = HTMLDivElement>(): [MutableRefObject<T | null>, Size] {
  const target = useRef<T | null>(null)
  const [size, setSize] = useState<Size>({
    width: 0,
    height: 0,
  })

  const updateSize = useCallback(
    ({ width, height }: Size) => {
      setSize({ width: Math.ceil(width), height: Math.ceil(height) })
    },
    [setSize],
  )

  useLayoutEffect(() => {
    if (target.current) {
      updateSize(target.current.getBoundingClientRect())
    }
  }, [updateSize])

  useResizeObserver(target, entry => updateSize(entry.contentRect))

  return [target, size]
}

export default useElementSize
